import { render, staticRenderFns } from "./frstScreenFormStart.vue?vue&type=template&id=3e1a8c4e&scoped=true"
import script from "./frstScreenFormStart.vue?vue&type=script&lang=js"
export * from "./frstScreenFormStart.vue?vue&type=script&lang=js"
import style0 from "./frstScreenFormStart.vue?vue&type=style&index=0&id=3e1a8c4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1a8c4e",
  null
  
)

export default component.exports